module.exports = __webpack_public_path__ + "img/ideas-illustration.d17bc13a.svg";